import React from "react";

const SitesIds = ({ row }) => {
  return (
    <div>
      <div style={{ paddingBottom: "10px" }}>{row?.site?.id}</div>
    </div>
  );
};

export default SitesIds;
